export const COUNTRY_SCALE = "countries"
export const COUNTY_SCALE = "counties"
export const DISTRICT_SCALE = "districts"
export const LOCATION_SCALE = "locations"
export const POSTAL_TOWN_SCALE = "cities"
export const REGION_SCALE = "regions"

export const DISTRICT_LONDON = "london"
export const DISTRICT_METRO = "metro"
export const DISTRICT_NON_METRO = "non_metro"
export const DISTRICT_ENGLISH_UNITARY = "english_unitary"
export const DISTRICT_SCOTTISH_UNITARY = "scottish_unitary"

export const getChildScales = (scale) => {
  switch (scale) {
    case COUNTRY_SCALE:
      return [
        { geographicScale: REGION_SCALE, districtType: null },
        {
          geographicScale: DISTRICT_SCALE,
          districtType: DISTRICT_SCOTTISH_UNITARY,
        },
      ]
    case COUNTY_SCALE:
      return [
        {
          geographicScale: DISTRICT_SCALE,
          districtType: null,
        },
      ]
    case REGION_SCALE:
      return [
        { geographicScale: COUNTY_SCALE, districtType: null },
        {
          geographicScale: DISTRICT_SCALE,
          districtType: DISTRICT_ENGLISH_UNITARY,
        },
        {
          geographicScale: DISTRICT_SCALE,
          districtType: DISTRICT_LONDON,
        },
      ]
    case DISTRICT_SCALE:
      return [{ geographicScale: POSTAL_TOWN_SCALE, districtType: null }]
    default:
      return []
  }
}
